import React, {Component} from 'react';

/** @class EditorColumn
  * A class representing a single column of content.
  * Must be placed within an EditorPanel.
  */
export default class EditorColumn extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div className="editor-column">
        {this.props.children}
      </div>
    );
  }
}

EditorColumn.propTypes = {}



// WEBPACK FOOTER //
// ./src/editor-components/editor-column.js